module.exports = __webpack_public_path__ + "static/step2-8b0134b5f6df67cf3edfdee9e7386e1e.svg";